<template>
    <v-col v-if="articles.length > 0" cols="12" :md="size" class="pt-0">
      <v-card>
        <router-link :to="{ name: 'TopicArticles', params:{id: topic_id} }">
          <v-card-title class="headline">
            <v-icon large left color="#91D4F4">{{icon}}</v-icon>
            <span @click="openTopic(topic_id)" class="header font-weight-bold color-black">{{topic_title}}</span>
          </v-card-title>
        </router-link>
        <div v-if="articles !== '[]'" style="height:100px;">
          <v-card-subtitle style="height:30px;" class="pt-1 pb-0" v-for="article in articles.slice(0, 3)">
            <router-link :to="{ name: 'ArticleDetail', params:{id: article.sys.id} }">
              <span v-if="$screen.width >= 1920" @click="openArticle(topic_id, article.sys.id)" class="color-black article-title">{{truncate(article.fields.title, 50)}}</span>
              <span v-else @click="openArticle(topic_id, article.sys.id)" class="color-black article-title">{{truncate(article.fields.title, 25)}}</span>
            </router-link>
          </v-card-subtitle>
        </div>
        <v-card-actions class="card-footer mt-2">
          <v-spacer></v-spacer>
          <router-link :to="{ name: 'TopicArticles', params:{id: topic_id} }">
            <v-btn class="btn-view" @click="openTopic(topic_id)" text small  color="white">View all articles</v-btn>
          </router-link>
        </v-card-actions>
      </v-card>
    </v-col>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['size', 'icon', 'topic_title', 'articles', 'topic_id', 'loading'],
  methods: {
    truncate (value, limit) {
      if (value.length > limit) {
        value = value.substring(0, (limit - 3)) + '..'
      }
      return value
    },
    openArticle(topicId, articleid) {
      this.$store.dispatch('getArticles', topicId)
      this.$store.dispatch('getArticle', articleid)
    },
    openTopic(topicId) {
      this.$store.dispatch('getArticles', topicId)
      this.$store.commit('setSearchedArticles', [])
      this.$store.commit('setQuery', '')
    }
  }
}
</script>
